export const TEST_ID = 'detailsViewCardHeaderDropdown';

export const DROPDOWN_DIRECTION = 'bottom';
